import MaterialBox from "../../../../__snowpack__/pkg/@mui/material/Box.js";
import styled from "styled-components";
export const FlexContainer = styled(MaterialBox).withConfig({
  displayName: "merge-unti-filter-modulestyles__FlexContainer",
  componentId: "sc-4xke13-0"
})(["", " & >:not(:last-child){", "}.MuiChip-root{", "}"], {
  display: "flex",
  alignItems: "flex-start",
  flexWrap: "wrap"
}, {
  marginRight: "0.5rem"
}, {
  marginBottom: "0.5rem"
});
export const PageActions = styled(MaterialBox).withConfig({
  displayName: "merge-unti-filter-modulestyles__PageActions",
  componentId: "sc-4xke13-1"
})(["", ""], {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "2rem"
});
